import { render, staticRenderFns } from "./AddTipo.vue?vue&type=template&id=7fc0d024&"
import script from "./AddTipo.vue?vue&type=script&lang=js&"
export * from "./AddTipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports